import { ROLES } from './roles';

export const PO_LINE_CLOSURE_REASONS = ['PART_CANCELLED'];

export const PO_LINE_CLOSURE_REASON_LABELS = {
  PART_CANCELLED: 'Part cancelled'
};

export const PO_LINE_CLOSEABLE_PO_STATUSES = ['ISSUED', 'PARTIALLY_RECEIVED', 'RECEIVED'];

export const MIN_PO_LINE_CLOSURE_REMARKS_LENGTH = 5;

export function canClosePoLine(po, line, userRole) {
  const canManage = [ROLES.STORE_EXECUTIVE, ROLES.STORE_INSPECTOR, ROLES.SUPER_ADMIN].includes(userRole);
  if (!canManage || !po || !line) return false;
  if (!PO_LINE_CLOSEABLE_PO_STATUSES.includes(po.status)) return false;
  if (line.lineStatus === 'CLOSED') return false;
  const received = Number(line.receivedQuantity) || 0;
  const ordered = Number(line.quantity) || 0;
  return received < ordered;
}
